/**
 * TODO: Unclear yet if this will be a 'global' view, or 'owned' by some other view.
 */
import Global from "/js/core/global";

export default class AccountView {

  #$el;
  #$image;
  #$accountText;
  #$signOutButton;

  constructor() {
    this.#$el = $("#accountView");
    this.#$image = this.#$el.find("#avatar");
    this.#$accountText = this.#$el.find("#accountText");
    this.#$signOutButton = this.#$el.find("#signOutButton");
  }

  show() {
    this.#$el.show();
  }

  hide() {
    this.#$el.hide();
  }

  get $signOutButton() {
    return this.#$signOutButton;
  }

  populate() {
    // Assumption is that Global.user exists.
    this.#$accountText.text(Global.user.accountText);  // TODO: sanitize data
    this.#$image[0].src = Global.user.imageUrl;  // TODO: sanitize data
  }
}
